import { Outlet } from 'react-router-dom';

import { Box, Card, CardContent, Typography } from '@mui/material';
import { Container } from '@mui/system';

import SettingsTabs from './components/settings-tabs/SettingsTabs';

export default function Settings() {
  return (
    <Box mt={5}>
      <Container className="disable-center">
        <Typography variant="h1" component="h1" className="with-indicator">
          Settings
        </Typography>

        <Box mt={6}>
          <SettingsTabs />
        </Box>

        <Card>
          <CardContent>
            <Outlet />
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
}
